/**
 * Reliable muted hero background video autoplay.
 * Safari often ignores HTML autoplay alone (timing, Low Power Mode, bfcache).
 */
(function initHeroVideo() {
  const video = document.querySelector(".hero__video");
  if (!video) return;

  function armMutedInline() {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    // Safari sometimes treats volume>0 as unmuted even with muted attr
    try {
      video.volume = 0;
    } catch (_err) {
      /* ignore */
    }
  }

  function tryPlay() {
    armMutedInline();
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Autoplay blocked (common in Safari Low Power Mode) — retry on next gesture
      });
    }
  }

  armMutedInline();

  if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
    tryPlay();
  } else {
    video.addEventListener("loadeddata", tryPlay, { once: true });
    video.addEventListener("canplay", tryPlay, { once: true });
  }

  // Retry when tab becomes visible again
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden && video.paused) tryPlay();
  });

  // bfcache / back-forward navigation
  window.addEventListener("pageshow", () => {
    if (video.paused) tryPlay();
  });

  // Low Power Mode: first tap/scroll unlocks autoplay
  const unlock = () => {
    if (video.paused) tryPlay();
  };
  ["touchstart", "click", "keydown"].forEach((evt) => {
    document.addEventListener(evt, unlock, { once: true, passive: true });
  });

  // Play when hero scrolls into view (Safari sometimes skips initial autoplay)
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && video.paused) tryPlay();
        });
      },
      { threshold: 0.25 }
    );
    observer.observe(video);
  }
})();
